import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { devIndexSearchSchema } from "@/modules/dev/registry/cycleFilter";

export const Route = createFileRoute("/dev/")({
  validateSearch: devIndexSearchSchema,
  component: lazyRouteComponent(
    () => import("@/modules/dev/screens/DevPreviewIndex"),
    "DevPreviewIndex",
  ),
});
